import React from 'react';
import {
  IconSearch,
  IconCategoryMultiday,
  IconCategoryDaytime,
  IconCategoryStays
} from '../../../../components';
import { languagesHelper as language } from '../../../../util/languages';
import { useIntl } from '../../../../util/reactIntl';

import css from './SearchLinks.module.css';

const SearchLinks = props => {
  const { config } = props;

  const { categoryConfiguration } = config;
  const { categories } = categoryConfiguration;
  const intl = useIntl();
  
  const dataForLinks = categories.map((item, index) => {
    switch (item.id) {
      case 'category-tours':
        return {
          id: index,
          key: item.id,
          name: item.name,
          type: item.id,
          icon: <IconCategoryMultiday />,
        };

      case 'category-experiences':
        return {
          id: index,
          key: item.id,
          name: item.name,
          type: item.id,
          icon: <IconCategoryDaytime />,
        };

      case 'category-stay':
        return {
          id: index,
          key: item.id,
          name: item.name,
          type: item.id,
          icon: <IconCategoryStays />,
        };

      default:
        return {
          id: index,
          name: 'Unknown',
          type: item.id,
          icon: null,
        };
    }
  });

  return (
    <div className={css.searchLinksWrapper}>
      {dataForLinks.map(item => {
        return (
          <a
            key={item.id}
            className={css.topbarLink}
            href={`/s?pub_categoryLevel1=${item.type}`}
          >
            <span className={css.searchLink}>
              {item.icon}
              <p>
                {language.labelsTranslator(item.key, intl)}
              </p>
            </span>
          </a>
        );
      })}
      <a
        key="search-button"
        className={css.topbarButton}
        href="/s"
      >
        <span className={css.searchButton}>
          <IconSearch />
          <span className={css.searchButtonText}>
            {intl.formatMessage({ id: 'PageBuilder.SearchCTA.buttonLabel' })}
          </span>
        </span>
      </a>
    </div>
  );
};

export default SearchLinks;
